import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/api/axios-instance";

export interface FormOption {
  source_id: string;
  name: string;
  department: string;
}

// All forms, for the submissions Category (department) + Title (form) filters.
// ponytail: one page of up to 100 forms covers the admin-managed form set.
async function getFormOptions(): Promise<FormOption[]> {
  const response = await axiosInstance.get("/forms", {
    params: { page: 0, limit: 100 },
  });
  const forms: Array<Partial<FormOption>> = response.data?.forms ?? [];
  return forms
    .filter((f) => f.source_id && f.name)
    .map((f) => ({
      source_id: f.source_id!,
      name: f.name!,
      department: f.department || "—",
    }));
}

export default function useFormOptions() {
  const { data } = useQuery<FormOption[]>({
    queryKey: ["form-options"],
    queryFn: getFormOptions,
    staleTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
  });
  return data ?? [];
}
